import ApplicationSerializer from './application';
import config from 'garaje/config/environment';
import { isPresent } from '@ember/utils';
import { service } from '@ember/service';

const { host, envoyHost } = config;

export default class LocationSerializer extends ApplicationSerializer {
  @service abilities;

  attrs = {
    blocklistContacts: 'blacklist-contacts',
    blocklistEnabled: 'blacklist-enabled',
    employeeScreeningEnabled: {
      serialize: false,
    },
    userDocumentRequirements: {
      serialize: false,
    },
  };

  serialize(snapshot, options) {
    const json = super.serialize(snapshot, options);

    if (this.abilities.cannot('update data-retention')) {
      delete json.data.attributes['entry-retention-period'];
      delete json.data.attributes['redact-all-visitor-data'];
    }

    if (this.abilities.cannot('update-visitor-reminders notification')) {
      delete json.data.attributes['visitor-reminder-threshold-minutes'];
    }

    return json;
  }

  normalizeQueryRecordResponse() {
    const response = this.normalizeQueryResponse(...arguments);
    response.data = response.data[0] || null;
    return response;
  }

  normalize(_typeClass, hash) {
    const attributes = hash.attributes;

    if (isPresent(attributes['pre-registration-link'])) {
      attributes['pre-registration-link'] = attributes['pre-registration-link'].replace(host, envoyHost);
    }
    if (isPresent(attributes['security-desk-link'])) {
      attributes['security-desk-link'] = attributes['security-desk-link'].replace(host, envoyHost);
    }
    return super.normalize(...arguments);
  }
}
